'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '5.2.2';


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch-core/dist/cjs/core/version.js
// module id = 456
// module chunks = 142807904292071